import emailjs from '@emailjs/browser';
import { useState } from 'react';

import FlashMessage from './FlashMessage';


const Form = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const [isSuccessful, setIsSuccessful] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    function clearInputs() {
        document.getElementById('name').value = '';
        document.getElementById('email').value = '';
        document.getElementById('subject').value = '';
        document.getElementById('message').value = '';
    }


    function hundleSubmit(e) {
        setIsSuccessful("");
        setIsLoading(true);
        e.preventDefault();
        const serviceId = "service_7eg5u1s";
        const templateId = "template_tx0sbwh";
        const publicKey = "Sjr_cKvgQla_26eLU";

        const templateParams = {
            from_name: name,
            from_email: email,
            from_subject: subject,
            from_message: message,
            to_name: "Begua Maamar Elhabib",
        }

        emailjs.send(serviceId, templateId, templateParams, publicKey)
            .then((response) => {
                console.log(response);
                setEmail('');
                setMessage('');
                setName('');
                setSubject('');
                setIsSuccessful(true);
                clearInputs();
            }).catch((error) => {
                console.log(error);
                setIsSuccessful(false);
            }).finally(() => {
                setIsLoading(false);
                
            });


    }

    return (
        <form className='w-60' onSubmit={hundleSubmit}>
            {isSuccessful !== "" ? <FlashMessage success={isSuccessful} message={isSuccessful ? "Message sent successfully, I will response as soon as possible" : "Failed to send message, please try later"} />  : ""}
            <div className="form-group my-3">
                <label for="name">Your name <span style={{ "color": "red" }}>*</span></label>
                <input type="text" className="" id="name" placeholder="Begua Maamar Elhabib" autoComplete="off" onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="form-group">
                <label for="email">Your Email <span style={{ "color": "red" }}>*</span></label>
                <input type="email" className="" id="email" placeholder="youremail@example.com" autoComplete="off" onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
                <label for="subject">Subject</label>
                <input type="text" className="" id="subject" placeholder="your subject" autoComplete='off' onChange={(e) => setSubject(e.target.value)} />
            </div>
            <div className="form-group">
                <label for="message">Message <span style={{ "color": "red" }}>*</span></label>
                <textarea className="" id="message" rows="3" onChange={(e) => setMessage(e.target.value)} required></textarea>
            </div>
            <div className="form-group mb-2">
                <button type="submit" className="btn btn-primary w-100">
                    {isLoading ? <div class="spinner-border" role="status">
                        <span class="sr-only"></span>
                    </div>
                        : "Send"}
                </button>
                
            </div>
        </form>
    )
}

export default Form